<template>
  <div class="tag-box">
    <div class="tag-box-title">| {{ $t('text.tag_data') }} |</div>
    <el-form
      ref="tagForm"
      :model="tagDataForm"
      :rules="tagDataRules"
      label-width="0px"
    >
      <el-form-item size="small" prop="tag">
        <el-select
          v-model="tagDataForm.tag"
          :placeholder="$t('text.please_select')"
          multiple
        >
          <el-option
            v-for="item in tagOptions"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item size="small" prop="notes">
        <el-input
          type="textarea"
          v-model="tagDataForm.notes"
          :placeholder="$t('text.notes') + '..'"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          @click="addTag()"
          :loading="saveTagLoading"
          class="cancel-btn min-w-80 mini-btn"
          >{{ $t('text.add_tag') }}</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { tagOptions } from '../const'
import ApiService from '@/services/CommonApiService.js'
import swal from 'sweetalert'
import moment from 'moment-timezone'
export default {
  data() {
    return {
      tagDataForm: {
        tag: [],
        notes: ''
      },
      tagDataRules: {
        tag: [
          {
            required: true,
            message: this.$t('text.please_select'),
            trigger: 'change'
          }
        ],
        notes: [
          {
            required: true,
            message: this.$t('text.please_enter'),
            trigger: 'blur'
          }
        ]
      },
      tagOptions: tagOptions,
      saveTagLoading: false
    }
  },
  props: {
    fromDate: {
      type: String,
      required: false
    },
    toDate: {
      type: String,
      required: false
    },
    podMac: {
      type: String,
      required: false
    },
    utcOffset: {
      type: String,
      required: false
    }
  },
  methods: {
    addTag() {
      this.$refs.tagForm.validate(valid => {
        if (valid) {
          this.saveTagLoading = true
          let user = JSON.parse(localStorage.getItem('user'))
          let params = {
            PodMac: this.podMac,
            TaggedBy: user.username,
            Tag: JSON.parse(JSON.stringify(this.tagDataForm.tag)).join(','),
            Notes: this.tagDataForm.notes,
            FromDate: moment(this.fromDate).format('YYYY-MM-DD HH:mm:ss'),
            ToDate: moment(this.toDate).format('YYYY-MM-DD HH:mm:ss')
          }
          ApiService.SaveDataTag(
            moment.tz(this.utcOffset).utcOffset() / 60,
            params
          )
            .then(response => {
              this.saveTagLoading = false
              if (response.data.success) {
                this.$emit('savedSuccess')
                swal({
                  icon: 'success',
                  timer: 2000,
                  title: this.$t('text.saved_successfully')
                })
              } else {
                swal({
                  icon: 'error',
                  timer: 2000,
                  title: 'Failed',
                  text: response.data.msg
                })
              }
            })
            .catch(() => {
              this.saveTagLoading = false
              swal({
                icon: 'error',
                timer: 2000,
                title: this.$t('text.failed')
              })
            })
        }
      })
    }
  }
}
</script>
